import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Role } from 'src/app/models/Role';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { getItemFromSessionStorage, ROLES } from 'src/app/utils/SessionStorageUtil';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.hasPermission(route);
  }

  constructor(private notificationService: NotificationService) {

  }
  
  public hasPermission(route: ActivatedRouteSnapshot): Observable<boolean> {

    if (!route.data) {
      return of(true);
    }
    
    let arrayRoles = getItemFromSessionStorage<Role>(ROLES);
    let hasPermission = false;

    if (arrayRoles) {
      hasPermission = route.data.permission.some((p: string) => arrayRoles?.roles.includes(p));
    }

    if (!hasPermission) {
      this.notificationService.error('Usuário sem permissão.', 'Para solicitar clique aqui.')
        .onAction()
        .subscribe(() => window.open('http://localhost', "_blank"));
    }

    return of(hasPermission);
  }

}
